module.exports = __webpack_public_path__ + "img/logo.a06187b3.png";